
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Space,
  Card
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { usePersistedStore } from "../../store/persisted-store";


export default function EndorsementUnderReviewReport() {
  const reports = useReportsStore()
  const {  business } = usePersistedStore();
  const data = reports.endorsementUnderReview.data.Items;
  const loading = reports.endorsementUnderReview.loading;
  const currentBusiness = business.currentBusiness;
  const { token } = currentBusiness;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");



  let searchInput;
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            ریست
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "نام بیمه گزار",
      dataIndex: "PolicyOwnerFullName",
      key: "PolicyOwnerFullName",
      width: 130,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.PolicyOwnerFullName ? (first = a.PolicyOwnerFullName) : (first = "");
        b.PolicyOwnerFullName ? (second = b.PolicyOwnerFullName) : (second = "");
        return first.localeCompare(second);
      },
      ...getColumnSearchProps("PolicyOwnerFullName", "نام بیمه گزار"),
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "نام درخواست کننده",
      dataIndex: "ApplicantFullName",
      key: "ApplicantFullName",
      width: 150,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
        b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
        return first.localeCompare(second);
      },
      ...getColumnSearchProps("ApplicantFullName", "نام درخواست کننده"),
      render: text => text && strings.getFarsiNum(text),
    },
    {
      title: "رشته",
      dataIndex: "BranchTitle",
      key: "BranchTitle",
      width: 90,
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: 80,
    },
    {
      title: "وضعیت",
      dataIndex: "StatusTitle",
      key: "StatusTitle",
      width: 130,
    },
    {
      title: "نوع الحاقیه",
      dataIndex: "TypeTitle",
      key: "TypeTitle",
      width: 150,
    },
    {
      title: "کدالحاقیه",
      dataIndex: "EndorsementId",
      key: "EndorsementId",
      ellipsis: true,
      width: 80,
      ...getColumnSearchProps('EndorsementId', 'کد درخواست'),
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "کد درخواست",
      dataIndex: "InsuranceRequestId",
      key: "InsuranceRequestId",
      ellipsis: true,
      width: 80,
      ...getColumnSearchProps('InsuranceRequestId', 'کد درخواست'),
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      key: "TrackingCode",
      width: 130,
      sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
      ...getColumnSearchProps('TrackingCode', 'کد رهگیری'),
      render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "SumPayment",
      key: "SumPayment",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ مغایرت",
      dataIndex: "ContradictionAmount",
      key: "ContradictionAmount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ",
      dataIndex: "Amount",
      key: "Amount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "کل مبلغ تخفیف",
      dataIndex: "SumDiscountsAmount",
      key: "SumDiscountsAmount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "تاریخ درخواست",
      dataIndex: "CreationTime",
      key: "CreationTime",
      width: 110,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.CreationTime ? first = a.CreationTime : first = '';
        b.CreationTime ? second = b.CreationTime : second = '';
        return first.localeCompare(second)
      },
      render: data => data && (data.CreationTime === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
    }
  ];

  useEffect(() => {
    if (token)
    reports.getEndorsementUnderReview();
  }, [token])

  return (
    <Card>
      <button type="primary"
        className="btn btn-primary waves-effect waves-light float-left" htmltype="submit"
        onClick={() => reports.getEndorsementUnderReview()} style={{ marginBottom: "20px" }}>
        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
      </button>
      <Table
        style={{ overflowX: 'scroll' }}
        className="custom-table"
        size="small"
        bordered
        columns={columns}
        loading={loading}
        rowKey="RequestId"
        scroll={true}
        dataSource={data}
      />
    </Card>
  );
}


